package com.milta.feature.route.domain.usecase

import com.milta.feature.delivery.domain.entity.AddressSuggestion
import com.milta.feature.route.domain.entity.Delivery
import com.milta.feature.route.domain.repository.RouteRepository

/** PUT /api/v1/routes/{routeId}/deliveries/{deliveryId}/address (MIL-99) — replaces an unlocated
 * stop's address with a picked HERE suggestion (its coordinates reused as-is). */
class UpdateDeliveryAddressUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(routeId: String, deliveryId: String, suggestion: AddressSuggestion): Delivery =
        repository.updateDeliveryAddress(routeId, deliveryId, suggestion.label, suggestion.latitude, suggestion.longitude)
}
